import { measureElement } from '@tanstack/react-virtual';

export const measureVisibleElement: typeof measureElement = (
  element,
  entry,
  instance,
) => {
  const size = measureElement(element, entry, instance);
  if (size > 0) {
    return size;
  }
  const index = instance.indexFromElement(element);
  return (
    instance.measurementsCache[index]?.size ??
    instance.options.estimateSize(index)
  );
};
